// ITP Service Exception codes
// Note: These must be in sync with service error code at ExceptionCodeConstants.cs

export const EnrollNewSubscriberFailedExceptionCode = '1053';
// When currently user does not have permission to access family member data or onboard family member
export const MemberPermissionsException = '1115';
export const GetQuestionsEditAndRetryErrorCode = '1130';
export const SubmitAnswersUnsuccessfulErrorCode = '1131';

// Unauthenticated One Time Scan (v2) constants
// "Exception Code: '1191'. Unauthenticated one-time cyberagent scan verification code sent limit exceeded."
export const UnauthOneTimeScanCodeGenerationLimitReached = '1191';
